import LoLExaminationActionButton from './LoLExaminationActionButton';

export default LoLExaminationActionButton;
